/**
 * KPIWidget Component
 * A component that displays Key Performance Indicators (KPIs) in a styled container.
 *
 * @param {Object} props - The props object containing the following properties:
 *   @param {string} title - The title of the KPIWidget.
 *   @param {Array<IDualKPIData>} data - An array of data objects containing the label and value for each KPI.
 *   @param {boolean} animated - A boolean flag to enable animated counting effect for KPI values using react-countup library.
 *   @param {string} infoMessage - The text that will be displayed on the info tooltip
 *
 * @returns {JSX.Element} - The rendered KPIWidget component.
 */

import * as Styled from './DualKPIWidget.styles';
import { IDualKPIWidget } from './DualKPIWidget.types';
import WidgetContainer from '../../Atoms/WidgetContainer/WidgetContainer';
import DualKPIWidgetSkeleton from './DualKPIWidget.skeleton';
import CountUp from 'react-countup';

const KPIWidget = (props: IDualKPIWidget) => {
  if (props.data) {
    return (
      <WidgetContainer
        isLoading={props.isLoading}
        title={props.title}
        infoMessage={props.infoMessage}
        maxWidth={600}
        error={props.error}
      >
        <Styled.KPIRow>
          {props.data?.map((node, i) => (
            <Styled.KPIColumn key={`${node.label}${i}`}>
              <Styled.KPIValue variant='h3'>
                {props.animated && <CountUp end={node.value} duration={0.5} />}
                {!props.animated && <>{node.value}</>}
              </Styled.KPIValue>
              <Styled.KPIUnit variant='body2'>{node.label}</Styled.KPIUnit>
            </Styled.KPIColumn>
          ))}
        </Styled.KPIRow>
      </WidgetContainer>
    );
  } else {
    return <DualKPIWidgetSkeleton error={props.error} />;
  }
};

export default KPIWidget;
